import React, { Component } from 'react';
import classNames from 'classnames';
import { NavItem } from '../../atoms';

import './styles.css';

/**
 * @typedef {Object} NavItemObj
 * @prop {React.ReactNode} children
 * @prop {string} href
 */

/**
 * A group of navigation items.
 *
 * @typedef {Object} Props
 * @prop {Array<NavItemObj>} navItems
 * @prop {string} [className]
 *
 * @augments {Component<Props>}
 */
export default class QrNavItemGroup extends Component {

	genClassName = (props) => classNames('QrNavItemGroup', props.className);

	genLiClassName = (displayAsButton) => classNames({ displayAsButton });

	mapChildren = ({ children, href, displayAsButton }) => (
		<li className={this.genLiClassName(!!displayAsButton)} key={children.toString()}>
			{href
				? <NavItem href={href}>
					{children}
				</NavItem>
				: <span>{children}</span>
			}
		</li>
	);

	render () {
		const className = this.genClassName(this.props);

		return (
			<nav className={className}>
				<ul>
					{this.props.navItems.map(this.mapChildren)}
				</ul>
			</nav>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/QrNavItemGroup/QrNavItemGroup.js